export interface ItemInputs {
    name: string;
    price: number;
    discount: number;
    priced_at?: string;
    price_default: number;
    shipping_fee: number;
    include_shipping_fee: boolean;
    shop_id: string;
    shop_item_id: string;
    shop_item_gid: string;
    shop_item_image_url: string;
    // compare
    compare_site: string;
    compare_url: string;
    compare_column: string;
    compare_pages?: number;
    extra_config: {
        naver_ungroup_sellers?: boolean;
        try_assign_my_compare_item?: boolean;
        [key: string]: unknown;
    };
    compare_range: "items_all" | "items_same_market" | "items_specified";
    rank_price_basis: "price_exposed" | "price";
    gap_price_basis: "price_exposed" | "price";
    compare_price_max: number;
    compare_price_min: number;
    // compare items
    compare_items_specified: string | Array<Record<string, unknown>>;
    compare_items_direct_specified: string | Array<Record<string, unknown>>;
    compare_items_prevented: string | Array<Record<string, unknown>>;
    compare_items_searched: unknown;
    my_compare_item_id?: string | null;
    my_compare_item: Record<string, unknown>;
    my_direct_compare_item_id?: string | null;
    my_direct_compare_item: Record<string, unknown>;



    target_rank?: number;
    desired_gap: number;

    // adjust strategies
    adjust_strategy: "adjust_price" | "adjust_discount" | "adjust_price_match_discount" | "adjust_discount_match_price";
    // ajdust configs
    adjust_no_exposed: any;
    skip_low_coupon: any;
    adjust_max_step: any;
    reset_max_step: any;
    reset_on_ll: any;
    reset_on_ll_countime: any;
    adjust_price_range: {
        use_global: boolean;
        is_enabled: boolean;
        value_min: number;
        value_min_type: string;
        value_max: number;
        value_max_type: string;
    };
    adjust_discount_range: {
        use_global: boolean;
        is_enabled: boolean;
        value_min: number;
        value_min_type: string;
        value_max: number;
        value_max_type: string;
    };
    adjust_price_exposed_range: any;
    competition_gap_limit: {
        mode: "competition_gap_limit";
        is_enabled: boolean;
        basis: "gap_price_basis";
        lower: {
            is_enabled: boolean;
            value: number;
            value_type: "percent" | "amount";
        };
        upper: {
            is_enabled: boolean;
            value: number;
            value_type: "percent" | "amount";
        };
    };

    // compare & adjust factors
    price_exposed?: number;
    target_price_exposed?: number;
    // listing
    itemgroup_id?: string | null;
    sort_order: number;
    // processing
    is_active: boolean;
    keep_default_price: boolean;
    // time table
    time_table?: string;
}

const RangeConfigDefault = {
    use_global: true,
    is_enabled: false,
    value_min: 0,
    value_min_type: "amount",
    value_max: 0,
    value_max_type: "amount"
};
const ValueConfigDefault = {
    use_global: true,
    is_enabled: false,
    value: 0,
    value_type: "amount"
};
const IsEnabledConfigDefault = {
    use_global: true,
    is_enabled: false
}

export const ItemInputsDefault: ItemInputs = {
    name: "",
    price: 0,
    discount: 0,
    priced_at: "",
    price_default: 0,
    shipping_fee: 0,
    include_shipping_fee: false,
    shop_id: "",
    shop_item_id: "",
    shop_item_gid: "",
    shop_item_image_url: "",
    // compare
    compare_site: "danawa",
    compare_url: "",
    compare_column: "left",
    extra_config: { naver_ungroup_sellers: false, try_assign_my_compare_item: false },
    compare_range: "items_all", // 기본값 추가
    rank_price_basis: "price_exposed",
    gap_price_basis: "price_exposed",
    compare_price_min: 0,
    compare_price_max: 0,
    target_rank: 1,
    compare_pages: 1,
    // compare items
    compare_items_searched: '[]',
    compare_items_specified: '[]',
    compare_items_direct_specified: '[]',
    compare_items_prevented: '[]',
    my_compare_item_id: null,
    my_compare_item: {},
    my_direct_compare_item_id: null,
    my_direct_compare_item: {},
    // adjust
    desired_gap: 0,
    adjust_strategy: "adjust_price",
    // adjust configs: item
    adjust_price_range: RangeConfigDefault,
    adjust_discount_range: RangeConfigDefault,
    adjust_price_exposed_range: RangeConfigDefault,
    competition_gap_limit: {
        mode: "competition_gap_limit",
        is_enabled: false,
        basis: "gap_price_basis",
        lower: { is_enabled: false, value: 0, value_type: "percent" },
        upper: { is_enabled: false, value: 0, value_type: "percent" },
    },
    // adjust configs: item & user
    adjust_no_exposed: IsEnabledConfigDefault,
    skip_low_coupon: ValueConfigDefault,
    adjust_max_step: ValueConfigDefault,
    reset_max_step: ValueConfigDefault,
    reset_on_ll: IsEnabledConfigDefault,
    reset_on_ll_countime: ValueConfigDefault,
    // adjust factors
    price_exposed: 0,
    target_price_exposed: 0,
    // listing
    itemgroup_id: null,
    sort_order: 50,
    // processing
    is_active: false,
    keep_default_price: false,
}
